// extracted by mini-css-extract-plugin
export default {"carouselGrid12":"aDlKKR","external":"bDlKKR","carouselGrid16":"cDlKKR","carouselGrid8":"dDlKKR"};